import { SidebarProps } from "@/types/components";
import { cn } from "@/utils/cn";
import {
  BarChart3,
  HelpCircle,
  MessageCircle,
  Settings,
  X,
} from "lucide-react";
import React from "react";

export const Sidebar: React.FC<SidebarProps> = ({
  isOpen,
  onClose,
  children,
  position = "left",
  width = "w-64",
  className = "",
}) => {
  const sidebarClasses = cn(
    "fixed top-0 h-full bg-white border-r border-gray-200 shadow-lg transform transition-transform duration-300 ease-in-out z-40",
    position === "left" ? "left-0" : "right-0",
    isOpen
      ? "translate-x-0"
      : position === "left"
      ? "-translate-x-full"
      : "translate-x-full",
    width,
    className
  );

  const overlayClasses = cn(
    "fixed inset-0 bg-black bg-opacity-50 z-30 transition-opacity duration-300",
    isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
  );

  const menuItems = [
    {
      icon: MessageCircle,
      label: "Chat",
      href: "/chat",
      active: true,
    },
    {
      icon: BarChart3,
      label: "Dashboard",
      href: "/dashboard",
      active: false,
    },
    {
      icon: Settings,
      label: "Configurações",
      href: "/settings",
      active: false,
    },
    {
      icon: HelpCircle,
      label: "Ajuda",
      href: "/help",
      active: false,
    },
  ];

  return (
    <>
      {/* Overlay */}
      <div className={overlayClasses} onClick={onClose} />

      {/* Sidebar */}
      <div className={sidebarClasses}>
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">Menu</h2>
          <button
            onClick={onClose}
            className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="Close sidebar"
          >
            <X size={20} />
          </button>
        </div>

        {/* Navigation Menu */}
        <nav className="p-4">
          <ul className="space-y-2">
            {menuItems.map((item) => {
              const IconComponent = item.icon;
              return (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className={cn(
                      "flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors",
                      item.active
                        ? "bg-primary-100 text-primary-700"
                        : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                    )}
                  >
                    <IconComponent size={20} />
                    <span className="font-medium">{item.label}</span>
                  </a>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Custom Content */}
        {children && (
          <div className="p-4 border-t border-gray-200">{children}</div>
        )}
      </div>
    </>
  );
};
